import React, { useState } from "react";
import { Formik } from "formik";
import queryString from "query-string";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import BoxPadraoSenha from "../../components/BoxPadraoSenha";
import CustomInput from "../../components/CustomInput";
import { useAlert } from "../../context/AlertContext";
import { login, primeiroAcesso } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import styles from "../../../styles/Login.module.css";
import { createFormikValidation } from "../../utils/Utils";
import * as utils from "../../../_metronic/utils/utils";

function PrimeiroAcesso(props) {
    const { usuario } = queryString.parse(props.location.search, { decode: false });

    const [submitting, setSubmitting] = useState(false);
    const history = useHistory();

    const { showAlert } = useAlert();

    const onSubmit = (values) => {
        setSubmitting(true);

        primeiroAcesso({ ...values, usuario })
            .then(() => {
                showAlert({
                    icon: "success",
                    title: "Sucesso!",
                    text: "Senha criada com sucesso.",
                    textStyle: { textAlign: 'center' },
                    confirmButton: true,
                    confirmText: "Ok",
                    onClose: () => entrar({ usuario, password: values.password })
                });
            })
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: 'center' },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            })
            .finally(() => setSubmitting(false));
    };

    const entrar = credentials => {
        login(credentials)
            .then((res) => {
                utils.setStorage("authToken", res.data.token, null);
                props.login(res.data);
                history.push("/");
            })
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: 'center' },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            })
            .finally(() => setSubmitting(false));
    };

    const getInitialValues = () => {
        return {
            password: "",
            password_confirmation: "",
        };
    };

    const validate = (values) => {
        const map = new Map();

        const errors = {};

        map.set("password", "senha");
        map.set("password_confirmation", "confirmar senha");

        if (values.password !== values.password_confirmation) {
            errors.password_confirmation = "As senhas não conferem.";
        }

        return { ...errors, ...createFormikValidation(map, values) };
    };

    return (
        <div className={styles.authContainer}>
            <div className={styles.loginContainer}>
                <div className={styles.loginLeft}>
                    <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                    <div className={styles.containerFormPrimeiroAcesso}>
                        <button type="button" className={styles.buttonBack} onClick={() => history.push("/")}>
                            <ArrowBackIosIcon />

                            <p>Primeiro acesso</p>
                        </button>

                        <p className={styles.textoPrimeiroAcesso}>Parece que esse é seu primeiro acesso. Crie uma senha para acessar sua conta.</p>

                        <Formik initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                                <form noValidate onSubmit={handleSubmit} className={styles.formLoginContainer}>
                                    <div style={{ flex: 1 }}>
                                        <div className={`${styles.formLogin} ${styles.divisor}`}>
                                            <CustomInput placeholder="Digite sua senha" required label="Senha" name="password" value={values.password} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} tipoInputRight="password" />

                                            <CustomInput placeholder="Confirme sua nova senha" required label="Confirmar senha" name="password_confirmation" value={values.password_confirmation} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} tipoInputRight="password" />
                                        </div>

                                        <BoxPadraoSenha values={values} name="password" />
                                    </div>

                                    <div className={`${styles.buttonContainer} ${styles.paddingButton}`}>
                                        <button type="submit" className={styles.buttonLogin} disabled={submitting}>
                                            {!submitting ? "Criar senha" : <div className="icon-loading" />}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className={styles.loginRight}>
                    <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                </div>
            </div>
        </div>
    );
}

export default connect(null, auth.actions)(PrimeiroAcesso);
